import React from 'react';

export const Pagination = ({ currentPage, totalPages, onPageChange, totalItems }) => {

    const renderPaginationItems = () => {
        const pages = [];
        const showPages = 5;

        // if (totalPages <= 1) return pages;

        // Always show the first page
        pages.push(
            <li key={1} className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
                <a
                    className={`page-link ${currentPage === 1 ? 'active' : ''}`}
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onPageChange(1);
                    }}
                >
                    1
                </a>
            </li>
        );

        if (totalPages > showPages) {
            let startPage = Math.max(currentPage - 1, 2);
            let endPage = Math.min(currentPage + 1, totalPages - 1);

            if (currentPage <= 3) {
                startPage = 2;
                endPage = 4;
            } else if (currentPage >= totalPages - 2) {
                startPage = totalPages - 3;
                endPage = totalPages - 1;
            }

            if (startPage > 2) {
                pages.push(
                    <li key="start-ellipsis" className="page-item disabled">
                        <span className="page-link">...</span>
                    </li>
                );
            }

            for (let i = startPage; i <= endPage; i++) {
                pages.push(
                    <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
                        <a
                            className={`page-link ${currentPage === i ? 'active' : ''}`}
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                onPageChange(i);
                            }}
                        >
                            {i}
                        </a>
                    </li>
                );
            }

            if (endPage < totalPages - 1) {
                pages.push(
                    <li key="end-ellipsis" className="page-item disabled">
                        <span className="page-link">...</span>
                    </li>
                );
            }

            pages.push(
                <li key={totalPages} className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
                    <a
                        className={`page-link ${currentPage === totalPages ? 'active' : ''}`}
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            onPageChange(totalPages);
                        }}
                    >
                        {totalPages}
                    </a>
                </li>
            );
        } else {
            for (let i = 2; i <= totalPages; i++) {
                pages.push(
                    <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
                        <a
                            className={`page-link ${currentPage === i ? 'active' : ''}`}
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                onPageChange(i);
                            }}
                        >
                            {i}
                        </a>
                    </li>
                );
            }
        }

        return pages;
    };

    return (
        <div className="pagenext">
            <div className="pageList">
                <p>Total {totalItems} items</p>
            </div>
            <div className="paginationBox">
                <nav aria-label="Page navigation example">
                    <ul className="pagination">
                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                            <a
                                className="page-link"
                                href="#"
                                aria-label="Previous"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage > 1) {
                                        onPageChange(currentPage - 1);
                                    }
                                }}
                            >
                                <span aria-hidden="true">
                                    <i className="bi bi-chevron-left"></i>
                                </span>
                            </a>
                        </li>
                        {renderPaginationItems()}
                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <a
                                className="page-link"
                                href="#"
                                aria-label="Next"
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage < totalPages) {
                                        onPageChange(currentPage + 1);
                                    }
                                }}
                            >
                                <span aria-hidden="true">
                                    <i className="bi bi-chevron-right"></i>
                                </span>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
};

